import { Directive, OnDestroy, OnInit, Optional } from '@angular/core';
import { MenuItemPlaceHolder } from './home-page/home-input/home-input-grid/grid-input-dialog/grid-input-dialog.component';
import { ContentStatusEnum, MenuItemContext, RendererType, Section } from '../editor-container/editor-model';
import { BehaviorSubject, Subject } from 'rxjs';
import { NbDialogRef, NbMenuItem, NbMenuService } from '@nebular/theme';
import { ContentElementEnum, ContentEnum, GridCell, RowCell } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from './sections-editor/shared-section-builder/section-builder-store.service';
import { EditorTemplateService } from './editor-template.service';
import { SafeStyle } from '@angular/platform-browser';
import { PreviewEditStoreService } from '../services/preview-edit-store.service';

export interface InputEditor{
  createSection(layoutClass:string):void;
  setTemporaryIds(section:Section):Section;
  setCellContentStatus(section:Section):Section;
  onSave(e:any):void;
  setPlaceholderImages(section:Section):Section;
  getLayoutClassValue(rawLayoutyClass):void
}

@Directive({
  selector: '[ngxBaseInputEditor]'
})
export class BaseInputEditorDirective implements OnInit,OnDestroy{
  menuItemPlaceHolders:MenuItemPlaceHolder[] = [];
  title:string;
  section:Section;

  status:ContentStatusEnum;

  rendererType:RendererType.GRID | RendererType.ROW | RendererType.BANNER | RendererType.TESTIMONIALS | RendererType.BLOGLIST | RendererType.HEROIMAGE;
  layoutClass:string;
  status$ = new BehaviorSubject(null);
  selectedCell:GridCell|RowCell;

  menuItems:NbMenuItem[] = [
    {
      title:"Cells",
      group:true
    }
  ];

  destroy$ = new Subject<void>();

  canSave = false;

  hasLoaded = false;

  svgData = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                   <rect width="200" height="200" fill="#cccccc" />
                   <text x="50%" y="50%" font-size="20" text-anchor="middle" fill="#777777" dy=".3em">Placeholder</text>
                 </svg>`;
  encodedSvg = encodeURIComponent(this.svgData);

  svgUrl = `data:image/svg+xml,${this.encodedSvg}`;

  svgBackground: SafeStyle;

  rendererTypeValue:string;
  cells:GridCell[]|RowCell[];
  
  constructor(
    protected menuService:NbMenuService,
    protected sectionBuilderStoreService:SectionBuilderStoreService,
    @Optional() protected ref: NbDialogRef<any>,
    protected editorTemplateService:EditorTemplateService) { }

  ngOnInit(): void {
    //this.createGridCells(this.layoutClass);
    //this.svgBackground = this.sanitizer.bypassSecurityTrustStyle(`url("${this.svgUrl}")`);
    
    /* this.section$.pipe(takeUntil(this.destroy$)).subscribe(section => {
      console.log(section);
        this.section = section
    }); */
    this.sectionBuilderStoreService.section$.subscribe(section => {
      if(section != undefined){
        console.log(section);
        this.section = section;
        this.status = this.section.status
        /* if(this.section.status != undefined) {
          this.status$.next(this.section.status);
        }else{
          this.status$.next(ContentStatusEnum.CTNT_IN_PROGRESS);
        } */
      }
      
    })
  }

  generateUniqueId() {
    const timestamp = Date.now(); // Get the current timestamp in milliseconds
    const randomNum = Math.floor(Math.random() * 1000000); // Generate a random number for extra uniqueness
    return `id-${timestamp}-${randomNum.toString(36)}`; // Combine timestamp and random number, convert to base-36
  }

  createMenu(gridCells:GridCell[]){
    //let menuItems:NbMenuItem = [];
    console.log(gridCells);
    gridCells.forEach(cell => {
      /* let menuItemPlaceHolder:MenuItemPlaceHolder = {
        cellId: cell.cellId,
        item: null
      } */
      const menuItem:NbMenuItem = {
        title:this.getMenuTitle(cell.contentEnum,"contentEnum"),
        children:this.getChildItems(cell)
      };
      const menuItemPlaceHolder:MenuItemPlaceHolder = {
        cellId: cell.cellId,
        item: menuItem
      }
      //menuItemPlaceHolder.item = menuItem;
      this.menuItemPlaceHolders.push(menuItemPlaceHolder);
      //this.menuItems.push(menuItem);
    })
    console.log(this.menuItemPlaceHolders);
    //this.menuService.addItems(this.menuItems,"inputMenu");
  }

  getMenuTitle(titleEnum,enumType:string){
    console.log(titleEnum,enumType);
    let title;
    if(enumType === "contentEnum"){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
        title = ContentEnum[enumKey];
      }else if(ContentEnum[titleEnum] != undefined){
        title = ContentEnum[titleEnum]
      }else{
        title = titleEnum;
      }
    }else if(enumType === "contentElementEnum"){
      if(titleEnum != undefined){
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          title = ContentElementEnum[enumKey];
        }else if(ContentElementEnum[titleEnum] != undefined){
          title = ContentElementEnum[titleEnum]
        }else{
          title = titleEnum;
        }
      }
      
    }
    console.log(title)    
    return title;
  }

  getChildItems(gridCell:GridCell):NbMenuItem[]{
    let items:NbMenuItem[] = [];
    let layoutContext:MenuItemContext = {
      cellId:gridCell.cellId,
      cell:gridCell,
      target:"layout"
    }
    let layoutItem:NbMenuItem = {
      title: 'Cell Layout',
      data:layoutContext
    }
    items.push(layoutItem);
    items.push({title:"Content Elements",group:true});
    gridCell.contentElements.forEach(el => {
      console.log(el)
      if(!el.contentElementEnum){
        console.log("No contentElementEnum: "+el.name);
        switch (el.name) {
          case "Footer":
            el.contentElementEnum = ContentElementEnum.ACTION;
            break;
          case "Text":
            el.contentElementEnum = ContentElementEnum.TEXT;
            break;
          case "Badge":
            el.contentElementEnum = ContentElementEnum.SUB_HEADER;
            break;
        
          default:
            break;
        }
      }
      const title = this.getMenuTitle(el.contentElementEnum,"contentElementEnum");
      const item:NbMenuItem = {
        title: title?title:el.elId
      }
      console.log(item);
      let context:MenuItemContext = {};
      context.elId = el.elId;
      context.contentElement = el;
      context.cellId = gridCell.cellId;
      context.cell = gridCell;
      item.data = context;
      console.log(item);
      items.push(item);
    })
    console.log(items)
    return items
  }

  updateSection(e){
    console.log(e);
    this.section = e;
    if(this.section.status != undefined){
      this.status = this.section.status;
      this.addMenuItems(this.section,this.menuItemPlaceHolders);
      this.canSave = this.trackCellStatusses(this.section);
      console.log(this.menuItemPlaceHolders);
      this.status$.next(this.section.status);
    }
    
  }

  addMenuItems(section:Section,menuItemPlaceHolders:MenuItemPlaceHolder[]):void{
    console.log(menuItemPlaceHolders)
    console.log(section.rendererType)
    let cells:GridCell[]|RowCell[];
    switch (this.getRendereTypeValue(section)) {
      case "grid":
        cells = section.sectionData.gridOptions.gridCells;
        break;
      case "row":
        cells = section.sectionData.rowOptions.rowCells;
        break;  
      case "banner":
        cells = section.sectionData.bannerOptions.gridCells; 
        break;
      case "bloglist":
        console.log("It's a bloglist")
        cells = section.sectionData.blogListOptions.rowCells;
        break;
      case "news-letter-sign-up":
        cells = section.sectionData.bannerOptions 
        break;
      case "store-features":
        cells = section.sectionData.gridOptions 
        break;
      case "slider":
        cells = section.sectionData.gridOptions 
        break;
      case "rich-text":
        cells = section.sectionData.gridOptions 
        break;
      case "testimonials":
        cells = section.sectionData.gridOptions 
        break;
      case "category":
        cells = section.sectionData.gridOptions 
        break;
      case "product":
        cells = section.sectionData.gridOptions 
        break;
      case "cart":
        cells = section.sectionData.gridOptions 
        break;
      case "blog":
        cells = section.sectionData.gridOptions 
        break;
      case "hero-image":
        cells = section.sectionData.gridOptions.gridCells 
        break;

      default:
        break;
    }
    this.cells = cells;
    cells.forEach(cell => {
      console.log(cell)
      if(cell.status == "Initial Draft"){
        let placeHolderItem = menuItemPlaceHolders.find(item => item.cellId == cell.cellId);
        if(placeHolderItem != undefined){
          const idx = menuItemPlaceHolders.indexOf(placeHolderItem);
          const placeHolderMenuItems = menuItemPlaceHolders.splice(idx,1);
          if(placeHolderMenuItems){
            let nbMenuItems = [];
            nbMenuItems.push(placeHolderMenuItems[0].item);
            this.menuService.addItems(nbMenuItems,"inputMenu");
          }
        }
      }
    })
  }

  trackCellStatusses(section:Section):boolean{
    let statusses = [];
    let canSave = false;

    //let gridCells:GridCell[] = section.sectionData.gridOptions.gridCells;
    this.cells.forEach(cell => {
      if(cell.status){
        statusses.push(cell.status);
      }
    })
    
    if(statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)){
      canSave = false;
    }else if(statusses.includes(ContentStatusEnum.CTNT_INITIAL_DRAFT) && !statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)){
      canSave = true
    }
    console.log(canSave);
    return canSave;
  }

  getRendereTypeValue(section:Section):string{
    let rendererTypeValue:string;
    let rendererType = section.rendererType;
    if((rendererType).includes(".")){
      let enumKey = rendererType.split('.')[1] as keyof typeof RendererType;
      rendererTypeValue = RendererType[enumKey];
    }else if(RendererType[rendererType] != undefined){
      rendererTypeValue = RendererType[rendererType]
    }else{
      rendererTypeValue = rendererType;
    }
    this.rendererTypeValue = rendererTypeValue;
    return rendererTypeValue
  }  

  getGridCellContentEnum(cell:GridCell|RowCell){
    let contentType:string;
    let cntEnum = cell.contentEnum;
    if((cntEnum).includes(".")){
      let enumKey = cntEnum.split('.')[1] as keyof typeof ContentEnum;
      contentType = ContentEnum[enumKey];
    }else if(ContentEnum[cntEnum] != undefined){
      contentType = ContentEnum[cntEnum]
    }else{
      contentType = cntEnum;
    }
    return contentType;
  }

  /* populateContentElements(fields:any[]):void{
    console.log("running populateContentElements")
    console.log(this.contentElements);
    this.contentElements.forEach(contentElement => {
      if(contentElement.fieldName == "productName" || contentElement.name == "Product Name"){
        contentElement.text = this.getFieldValue("productName",fields);
        console.log(contentElement)
      }
      if(contentElement.fieldName == "price" || contentElement.name == "Price"){
        contentElement.text = this.getFieldValue("price",fields);
        console.log(contentElement)
      }
    })
    console.log(fields);
    let smallImageUrl = this.getFieldValue("smallImageUrl",fields);
    if(smallImageUrl != undefined){
      //clean url of htmlsafe characters
      smallImageUrl = decodeURIComponent(smallImageUrl);
      let baseUrl = this.baseUrl.replace("rest/","");
      this.imgSrc = baseUrl+smallImageUrl;
      this.cell.imgSrc = this.imgSrc;
      this.showPlaceholder = false;
      console.log(this.imgSrc)
    }



  } */

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}


